const initialState = {
    fetching: false,
    step: null,
    erors: [],
};

export default function forgotPassword(state = initialState, action) {
    switch( action.type ) {
        case 'REQUESTING_PASSWORD_RESET_EMAIL':
            return {
                ...state,
                fetching: true,
                errors: [],
            };
        case 'PASSWORD_RESET_EMAIL_REQUEST_RESPONSE':
            return {
                ...state,
                fetching: false,
                errors: action.errors,
            };
        default:
            return state;
    }
}
